import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { AlertTriangle } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const POLL_MS = 15000;

// Rotte pubbliche / schermi dove il banner non deve comparire.
const HIDDEN_PREFIXES = ["/login", "/auth", "/reset-password", "/accept-invite", "/feedback-form", "/monitor"];

export default function GhlRateLimitBanner() {
  const location = useLocation();
  const [active, setActive] = useState(false);
  const timerRef = useRef(null);

  const hidden = HIDDEN_PREFIXES.some((p) => location.pathname.startsWith(p));

  useEffect(() => {
    if (hidden) {
      setActive(false);
      return undefined;
    }
    let cancelled = false;

    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/api/ghl/rate-limit-status`, { withCredentials: true });
        if (!cancelled) setActive(Boolean(data?.rate_limited));
      } catch (e) {
        // 401 (non loggato) o errore rete → non mostrare nulla.
        if (!cancelled) setActive(false);
      }
    };

    poll();
    timerRef.current = setInterval(poll, POLL_MS);
    return () => {
      cancelled = true;
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [hidden, location.pathname]);

  if (hidden || !active) return null;

  return (
    <div
      data-testid="ghl-rate-limit-banner"
      className="fixed bottom-0 left-0 right-0 z-[9999] bg-amber-500 text-amber-950 shadow-[0_-2px_8px_rgba(0,0,0,0.1)]"
    >
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center gap-2 text-sm font-medium">
        <AlertTriangle className="w-4 h-4 shrink-0" />
        <span>
          GHL temporaneamente sotto rate-limit — i dati potrebbero essere in cache, le azioni restano attive.
        </span>
      </div>
    </div>
  );
}
